<template>
  <div>
    <date-picker
      v-if="showLunar"
      width="100%"
      @change="change"
      :workdata="workdata"
      :startMonth="month"
    ></date-picker>
    <date v-if="!showLunar" width="100%" :workdata="workdata" @on-date-select="showDetail"></date>
  </div>
</template>
<script>
import datePicker from "./datePicker.vue";
import date from "./date.vue";
export default {
  name: "OACalendar",
  props: {
    workdata: {
      default: []
    },
    month: {
      default: null
    },
    showLunar: {
      default: true
    }
  },
  components: {
    datePicker,
    date
  },
  data() {
    return {};
  },
  methods: {
    change(day) {
      this.$emit("change", day);
    },
    showDetail(day) {
      this.$emit("showDetail", day);
    }
  },
  mounted() {}
};
</script>





// WEBPACK FOOTER //
// src/components/OACalendar/OACalendar.vue